import React from 'react';
import PropTypes from 'prop-types';

// styles
import styles from './FormLabel.module.less';

const FormLabel = ({
  largeLabel = false,
  boldLabel = false,
  children
}) => {
  if (!children) return null;

  const classnames = `
    ${styles.formLabel}
    ${largeLabel ? styles.formLabelLarge : ''}
    ${boldLabel ? styles.formBoldLabel : ''}
  `;

  return <label className={classnames}>{children}</label>
};

FormLabel.propTypes = {
  largeLabel: PropTypes.bool,
  boldLabel: PropTypes.bool,
};

export default FormLabel;



// WEBPACK FOOTER //
// ./src/components/HookFormInputs/FormLabel.jsx